<template>
  <section id="wrapper" class="error-page">
    <div class="error-box">
      <div class="error-body text-center">
        <h1>404</h1>
        <h3 class="text-uppercase">
          <template v-if="trans('general.page_not_found_heading')"> {{ trans('general.page_not_found_heading') }} </template>
          <template v-else>Ошибка</template>
        </h3>
        <p class="text-muted m-t-30 m-b-30">
          <template v-if="trans('general.page_not_found_message')"> {{ trans('general.page_not_found_message') }}</template>
          <template v-else> Страница не найдена</template>
        </p>
        <router-link
          to="/"
          class="btn btn-info btn-rounded waves-effect waves-light m-b-40"
        >
          <template v-if="trans('general.back_to_home')"> {{ trans('general.back_to_home') }} </template>
          <template v-else> На главную </template>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {}
};
</script>
